import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import PageHeader from '../../components/PageHeader/PageHeader';
import FilterCard from '../../components/FilterCard/FilterCard';
import './Yayinlar.css';
import { BsArrowUpRight, BsDownload, BsEye } from 'react-icons/bs';
import SummaryCard from '../../components/SummaryCard/SummaryCard';

const institutionName = process.env.REACT_APP_INSTITUTION_NAME;
const institutionShortName = process.env.REACT_APP_INSTITUTION_SHORT_NAME;
const institutionType = process.env.REACT_APP_INSTITUTION_TYPE;

const yayinlarData = {
  ozet: {
    detayliMetrikler: {
      "Öğretim Üyesi Başına Düşen Yayın": {
        2022: 0.512,
        2023: 0.571,
        2024: 0.583
      },
      "Öğretim Üyesi Başına Düşen Atıf": {
        2022: 1.22,
        2023: 1.45,
        2024: 1.67
      },
      "Öğretim Üyesi Başına Düşen Q1 Yayın": {
        2022: 0.422,
        2023: 0.455,
        2024: 0.478
      },
      "Toplam Yayın": {
        2022: 245,
        2023: 268,
        2024: 275
      },
      "Toplam Atıf": {
        2022: 980,
        2023: 1250,
        2024: 1480
      },
      "Toplam Q1 Yayın": {
        2022: 156,
        2023: 178,
        2024: 189
      },
      "Q1 Yayın Oranı": {
        2022: 63.7,
        2023: 66.4,
        2024: 68.7
      },
      "Q2 Yayın Oranı": {
        2022: 20.8,
        2023: 21.8,
        2024: 21.4
      },
      "Q3 Yayın Oranı": {
        2022: 10.2,
        2023: 8.6,
        2024: 7.2
      },
      "Q4 Yayın Oranı": {
        2022: 5.3,
        2023: 3.2,
        2024: 2.7
      }
    }
  },
  filtreler: {
    yillar: ["2024", "2023", "2022"],
    indeksler: ["SCI", "SCI-E", "SSCI", "AHCI"],
    qKategorileri: ["Q1", "Q2", "Q3", "Q4"],
    bolumler: ["Bilişim Enstitüsü", "Enerji Enstitüsü", "Metalurji ve Malzeme Müh.", "Robotik ve Otonom Sistemler"],
    yayinTurleri: ["Makale", "Konferans Bildirisi", "Kitap", "Kitap Bölümü"]
  }
};

const ituYayinVerileri = {
  yillar: ['2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'],
  toplamYayin: [5512, 5713, 5714, 5864, 5864.8, 5864.8, 5864.8, 5864.8],
  q1Yuzde: [50.12, 54.14, 57.14, 58.64, 58.64, 58.64, 58.64, 58.64],
  q2Yuzde: [20.12, 21.14, 21.14, 21.64, 21.64, 21.64, 21.64, 21.64],
  q3Yuzde: [15.12, 14.14, 12.14, 11.64, 11.64, 11.64, 11.64, 11.64],
  q4Yuzde: [14.64, 10.58, 9.58, 8.08, 8.08, 8.08, 8.08, 8.08],
  atifSayisi: [5512, 5713, 5714, 5864, 5864.8, 5864.8, 5864.8, 5864.8],
  ogretimUyesiBasinaYayin: [0.512, 0.513, 0.514, 0.564, 0.564, 0.564, 0.564, 0.564],
  ogretimUyesiBasinaAtif: [1.512, 1.513, 1.514, 1.564, 1.564, 1.564, 1.564, 1.564],
  ogretimUyesiBasinaQ1: [0.312, 0.313, 0.314, 0.364, 0.364, 0.364, 0.364, 0.364]
};

const ozetKartVerileri = [
  {
    id: 1,
    yil: 2024,
    deger: "5.25",
    tip: "Atıf/Yayın",
    trend: "up"
  },
  {
    id: 2,
    yil: 2023,
    deger: "4.1",
    tip: "Atıf/Yayın",
    trend: "up"
  },
  {
    id: 3,
    yil: 2024,
    deger: "2.5",
    tip: "Yayın",
    trend: "down"
  },
  {
    id: 4,
    yil: 2024,
    deger: "1564",
    tip: "Öğretim Üyesi",
    trend: "up"
  },
  {
    id: 5,
    yil: 2024,
    deger: "5864",
    tip: "Toplam Yayın",
    trend: "up"
  },
  {
    id: 6,
    yil: 2024,
    deger: "15240",
    tip: "Toplam Atıf",
    trend: "up"
  }
];

const detayliVeriler = {
  yillar: ['2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'],
  veriler: [
    {
      baslik: "Toplam Yayın",
      degerler: [5512, 5713, 5714, 5864, 5864.8, 5864.8, 5864.8, 5864.8]
    },
    {
      baslik: "Öğretim Üyesi Sayısı",
      degerler: [1512, 1513, 1514, 1564, 1564, 1564, 1564, 1564]
    },
    {
      baslik: "Öğretim Üyesi Başına Yayın",
      degerler: [0.512, 0.513, 0.514, 0.564, 0.564, 0.564, 0.564, 0.564]
    },
    {
      baslik: "Atıf Sayısı",
      degerler: [5512, 5713, 5714, 5864, 5864.8, 5864.8, 5864.8, 5864.8]
    },
    {
      baslik: "Öğretim Üyesi Başına Atıf",
      degerler: [1.512, 1.513, 1.514, 1.564, 1.564, 1.564, 1.564, 1.564]
    },
    {
      baslik: "Q1 Yayın Sayısı",
      degerler: [2512, 2513, 2514, 2564, 2564, 2564, 2564, 2564]
    },
    {
      baslik: "Q2 Yayın Sayısı",
      degerler: [1512, 1513, 1514, 1564, 1564, 1564, 1564, 1564]
    },
    {
      baslik: "Q3 Yayın Sayısı",
      degerler: [812, 813, 814, 864, 864, 864, 864, 864]
    },
    {
      baslik: "Q4 Yayın Sayısı",
      degerler: [512, 513, 514, 564, 564, 564, 564, 564]
    },
    {
      baslik: "Q1 Yüzdesi",
      degerler: [50.12, 54.14, 57.14, 58.64, 58.64, 58.64, 58.64, 58.64]
    },
    {
      baslik: "Q2 Yüzdesi",
      degerler: [20.12, 21.14, 21.14, 21.64, 21.64, 21.64, 21.64, 21.64]
    },
    {
      baslik: "Q3 Yüzdesi",
      degerler: [15.12, 14.14, 12.14, 11.64, 11.64, 11.64, 11.64, 11.64]
    },
    {
      baslik: "Q4 Yüzdesi",
      degerler: [14.64, 10.58, 9.58, 8.08, 8.08, 8.08, 8.08, 8.08]
    },
    {
      baslik: "Öğretim Üyesi Başına Q1 Yayın",
      degerler: [0.312, 0.313, 0.314, 0.364, 0.364, 0.364, 0.364, 0.364]
    },
    {
      baslik: "Öğretim Üyesi Başına Q2 Yayın",
      degerler: [0.212, 0.213, 0.214, 0.264, 0.264, 0.264, 0.264, 0.264]
    },
    {
      baslik: "Öğretim Üyesi Başına Q3 Yayın",
      degerler: [0.112, 0.113, 0.114, 0.164, 0.164, 0.164, 0.164, 0.164]
    },
    {
      baslik: "Öğretim Üyesi Başına Q4 Yayın",
      degerler: [0.082, 0.083, 0.084, 0.094, 0.094, 0.094, 0.094, 0.094]
    }
  ]
};

const toplamMakaleBilgileri = {
  toplamMakale2024: 2064,
  toplamMakaleSonBesYil: 9461,
  q1: {
    sayi2024: 1409,
    yuzde2024: 69.3,
    sonBesYil: 5798
  },
  q2: {
    sayi2024: 488,
    yuzde2024: 23.6,
    sonBesYil: 2058
  },
  mr: {
    sayi2024: 137,
    sonBesYil: 1007
  }
};

const ituOzetBilgileri = {
  ogretimUyesiSayisi: 1231,
  makaleVeReviewSayisi2024: 2064,
  ogretimUyesiBasinaQ1Q22024: 1.54,
  ogretimUyesiBasinaMRSayisi2024: 1.68,
  ogretimUyesiBasinaQ12024: 1.15,
  ogretimUyesiBasinaQ22024: 0.40,
  q12024: 1409,
  q22024: 488,
  q1q22024: 1897,
  q1Yuzdesi: 68.3,
  q2Yuzdesi: 23.6,
  q1q2Yuzdesi: 91.9
};

const fakulteQ1Q2Verileri = {
  yillar: ['2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'],
  fakulteler: [
    {
      ad: "İTÜ",
      veriler: [96.0, 94.2, 94.0, 94.2, 94.5, 94.5, 95.0, 95.2]
    },
    {
      ad: "Uçak ve Uzay Bilimleri Fakültesi",
      veriler: [97.8, 97.7, 97.3, 97.2, 96.2, 96.4, 96.2, 96.1]
    },
    {
      ad: "Denizcilik Fakültesi",
      veriler: [95.0, 94.7, 95.0, 97.8, 95.4, 95.3, 95.0, 94.5]
    },
    {
      ad: "Elektrik-Elektronik Fakültesi",
      veriler: [92.7, 95.0, 95.6, 97.8, 96.4, 97.6, 96.7, 95.6]
    },
    {
      ad: "Fen-Edebiyat Fakültesi",
      veriler: [94.0, 94.9, 95.2, 94.5, 95.2, 94.0, 95.8, 94.9]
    },
    {
      ad: "Gemi İnşaatı ve Deniz Bilimleri Fakültesi",
      veriler: [97.2, 95.7, 97.8, 94.7, 94.3, 94.7, 94.5, 95.2]
    },
    {
      ad: "İnşaat Fakültesi",
      veriler: [94.0, 94.5, 94.5, 97.3, 94.7, 94.5, 95.8, 95.2]
    },
    {
      ad: "İşletme Fakültesi",
      veriler: [92.0, 97.2, 94.8, 94.2, 94.1, 94.0, 94.3, 92.7]
    },
    {
      ad: "Kimya-Metalurji Fakültesi",
      veriler: [94.5, 97.5, 97.4, 94.7, 94.4, 95.1, 95.1, 95.3]
    },
    {
      ad: "Makine Fakültesi",
      veriler: [94.7, 94.2, 94.7, 95.5, 97.8, 94.0, 94.8, 94.8]
    },
    {
      ad: "Mimarlık Fakültesi",
      veriler: [94.7, 97.7, 94.0, 93.8, 94.4, 95.9, 95.7, 93.7]
    },
    {
      ad: "Tekstil Teknolojileri ve Tasarımı Fakültesi",
      veriler: [94.5, 92.5, 97.5, 97.0, 97.0, 94.3, 94.7, 94.7]
    },
    {
      ad: "Bilgisayar ve Bilişim Fakültesi",
      veriler: [94.2, 94.8, 94.5, 95.7, 94.3, 94.1, 95.1, 92.7]
    }
  ]
};

const ogretimUyesiBasinaMakaleVerileri = {
  yillar: ['2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'],
  fakulteler: [
    {
      ad: "İTÜ",
      veriler: [1.06, 1.14, 1.27, 1.34, 1.53, 1.58, 1.82, 1.85]
    },
    {
      ad: "Uçak ve Uzay Bilimleri Fakültesi",
      veriler: [1.24, 0.98, 0.61, 0.94, 1.04, 1.35, 1.24, 1.31]
    },
    {
      ad: "Denizcilik Fakültesi",
      veriler: [0.80, 0.60, 0.95, 1.08, 0.72, 1.20, 1.86, 1.85]
    },
    {
      ad: "Elektrik-Elektronik Fakültesi",
      veriler: [0.79, 1.05, 1.28, 1.29, 1.45, 1.54, 1.89, 1.90]
    },
    {
      ad: "Fen-Edebiyat Fakültesi",
      veriler: [1.65, 1.98, 2.09, 2.01, 1.69, 1.76, 1.81, 1.41]
    },
    {
      ad: "Gemi İnşaatı ve Deniz Bilimleri Fakültesi",
      veriler: [0.67, 0.78, 0.67, 0.81, 1.00, 1.11, 1.03, 1.17]
    },
    {
      ad: "İnşaat Fakültesi",
      veriler: [0.95, 0.88, 1.04, 1.31, 1.33, 1.61, 1.98, 1.91]
    },
    {
      ad: "İşletme Fakültesi",
      veriler: [1.22, 1.04, 1.05, 1.17, 1.13, 1.05, 1.39, 1.26]
    },
    {
      ad: "Kimya-Metalurji Fakültesi",
      veriler: [1.49, 1.28, 1.85, 2.11, 1.92, 2.00, 3.06, 2.66]
    },
    {
      ad: "Makine Fakültesi",
      veriler: [0.76, 0.78, 0.87, 0.90, 0.84, 1.01, 1.11, 1.02]
    },
    {
      ad: "Mimarlık Fakültesi",
      veriler: [0.35, 0.23, 0.35, 0.36, 0.53, 0.53, 0.63, 0.65]
    },
    {
      ad: "Tekstil Teknolojileri ve Tasarımı Fakültesi",
      veriler: [1.75, 1.33, 1.42, 1.29, 1.83, 2.00, 1.86, 1.42]
    },
    {
      ad: "Bilgisayar ve Bilişim Fakültesi",
      veriler: [0.94, 1.23, 1.29, 1.19, 1.05, 2.26, 1.65, 1.28]
    }
  ]
};

const ogretimUyesiBasinaMakaleOptions = {
  chart: {
    type: 'column',
    height: 600
  },
  title: {
    text: `${institutionShortName} Fakülte Bazında Öğretim Üyesi Başına Makale + Review Sayısı`
  },
  xAxis: {
    categories: ogretimUyesiBasinaMakaleVerileri.yillar,
    labels: {
      rotation: -45
    }
  },
  yAxis: {
    title: {
      text: 'Makale Sayısı'
    }
  },
  plotOptions: {
    column: {
      pointPadding: 0.2,
      borderWidth: 0
    },
    line: {
      lineWidth: 3,
      marker: {
        enabled: true,
        radius: 6
      }
    }
  },
  series: [
    {
      name: 'İTÜ',
      type: 'line',
      data: ogretimUyesiBasinaMakaleVerileri.fakulteler.find(f => f.ad === "İTÜ").veriler,
      color: '#FF0000',
      zIndex: 2,
      lineWidth: 3,
      marker: {
        enabled: true,
        radius: 6
      }
    },
    ...ogretimUyesiBasinaMakaleVerileri.fakulteler
      .filter(fakulte => fakulte.ad !== "İTÜ")
      .map(fakulte => ({
        name: fakulte.ad,
        type: 'column',
        data: fakulte.veriler
      }))
  ]
};

const q1q2YuzdesiOptions = {
  chart: {
    type: 'column',
    height: 600
  },
  title: {
    text: `${institutionShortName} Q1 + Q2 YÜZDESİ`
  },
  xAxis: {
    categories: fakulteQ1Q2Verileri.yillar,
    labels: {
      rotation: -45
    }
  },
  yAxis: {
    min: 0,
    max: 100,
    title: {
      text: 'Yüzde (%)'
    }
  },
  plotOptions: {
    column: {
      pointPadding: 0.2,
      borderWidth: 0
    },
    line: {
      lineWidth: 3,
      marker: {
        enabled: true,
        radius: 6
      }
    }
  },
  series: [
    {
      name: 'İTÜ',
      type: 'line',
      data: fakulteQ1Q2Verileri.fakulteler.find(f => f.ad === "İTÜ").veriler,
      color: '#FF0000',
      zIndex: 2,
      lineWidth: 3,
      marker: {
        enabled: true,
        radius: 6
      }
    },
    ...fakulteQ1Q2Verileri.fakulteler
      .filter(fakulte => fakulte.ad !== "İTÜ")
      .map(fakulte => ({
        name: fakulte.ad,
        type: 'column',
        data: fakulte.veriler
      }))
  ]
};

const enstituYayinDetayVerileri = [
  {
    ad: "İTÜ",
    ogretimUyesiSayisi: 1231,
    toplamYayin: 2064,
    q1Yayin: 1409,
    q2Yayin: 488,
    q3Yayin: 120,
    q4Yayin: 47,
    ogretimUyesiBasinaYayin: 1.68,
    ogretimUyesiBasinaQ1: 1.15,
    ogretimUyesiBasinaQ2: 0.40,
    q1Yuzdesi: 68.3,
    q2Yuzdesi: 23.6,
    q1q2Yuzdesi: 91.9
  },
  {
    ad: "Fen Bilimleri Enstitüsü",
    ogretimUyesiSayisi: 425,
    toplamYayin: 812,
    q1Yayin: 568,
    q2Yayin: 195,
    q3Yayin: 35,
    q4Yayin: 14,
    ogretimUyesiBasinaYayin: 1.91,
    ogretimUyesiBasinaQ1: 1.34,
    ogretimUyesiBasinaQ2: 0.46,
    q1Yuzdesi: 70.0,
    q2Yuzdesi: 24.0,
    q1q2Yuzdesi: 94.0
  },
  {
    ad: "Sosyal Bilimler Enstitüsü",
    ogretimUyesiSayisi: 185,
    toplamYayin: 250,
    q1Yayin: 168,
    q2Yayin: 68,
    q3Yayin: 10,
    q4Yayin: 4,
    ogretimUyesiBasinaYayin: 1.35,
    ogretimUyesiBasinaQ1: 0.91,
    ogretimUyesiBasinaQ2: 0.37,
    q1Yuzdesi: 67.2,
    q2Yuzdesi: 27.2,
    q1q2Yuzdesi: 94.4
  },
  {
    ad: "Bilişim Enstitüsü",
    ogretimUyesiSayisi: 95,
    toplamYayin: 185,
    q1Yayin: 128,
    q2Yayin: 45,
    q3Yayin: 8,
    q4Yayin: 4,
    ogretimUyesiBasinaYayin: 1.95,
    ogretimUyesiBasinaQ1: 1.35,
    ogretimUyesiBasinaQ2: 0.47,
    q1Yuzdesi: 69.2,
    q2Yuzdesi: 24.3,
    q1q2Yuzdesi: 93.5
  },
  {
    ad: "Enerji Enstitüsü",
    ogretimUyesiSayisi: 65,
    toplamYayin: 124,
    q1Yayin: 86,
    q2Yayin: 31,
    q3Yayin: 5,
    q4Yayin: 2,
    ogretimUyesiBasinaYayin: 1.91,
    ogretimUyesiBasinaQ1: 1.32,
    ogretimUyesiBasinaQ2: 0.48,
    q1Yuzdesi: 69.4,
    q2Yuzdesi: 25.0,
    q1q2Yuzdesi: 94.4
  },
  {
    ad: "Avrasya Yer Bilimleri Enstitüsü",
    ogretimUyesiSayisi: 45,
    toplamYayin: 84,
    q1Yayin: 58,
    q2Yayin: 22,
    q3Yayin: 3,
    q4Yayin: 1,
    ogretimUyesiBasinaYayin: 1.87,
    ogretimUyesiBasinaQ1: 1.29,
    ogretimUyesiBasinaQ2: 0.49,
    q1Yuzdesi: 69.0,
    q2Yuzdesi: 26.2,
    q1q2Yuzdesi: 95.2
  }
];

const enstituOgretimUyesiBasinaMakaleVerileri = {
  yillar: ['2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'],
  enstituler: [
    {
      ad: "İTÜ",
      veriler: [1.06, 1.14, 1.27, 1.34, 1.53, 1.58, 1.82, 1.85]
    },
    {
      ad: "Fen Bilimleri Enstitüsü",
      veriler: [1.24, 0.98, 0.61, 0.94, 1.04, 1.35, 1.24, 1.31]
    },
    {
      ad: "Sosyal Bilimler Enstitüsü",
      veriler: [0.80, 0.60, 0.95, 1.08, 0.72, 1.20, 1.86, 1.85]
    },
    {
      ad: "Bilişim Enstitüsü",
      veriler: [0.79, 1.05, 1.28, 1.29, 1.45, 1.54, 1.89, 1.90]
    },
    {
      ad: "Enerji Enstitüsü",
      veriler: [1.65, 1.98, 2.09, 2.01, 1.69, 1.76, 1.81, 1.41]
    },
    {
      ad: "Avrasya Yer Bilimleri Enstitüsü",
      veriler: [0.67, 0.78, 0.67, 0.81, 1.00, 1.11, 1.03, 1.17]
    },
    {
      ad: "İnşaat Fakültesi",
      veriler: [0.95, 0.88, 1.04, 1.31, 1.33, 1.61, 1.98, 1.91]
    },
    {
      ad: "İşletme Fakültesi",
      veriler: [1.22, 1.04, 1.05, 1.17, 1.13, 1.05, 1.39, 1.26]
    },
    {
      ad: "Kimya-Metalurji Fakültesi",
      veriler: [1.49, 1.28, 1.85, 2.11, 1.92, 2.00, 3.06, 2.66]
    },
    {
      ad: "Makine Fakültesi",
      veriler: [0.76, 0.78, 0.87, 0.90, 0.84, 1.01, 1.11, 1.02]
    },
    {
      ad: "Mimarlık Fakültesi",
      veriler: [0.35, 0.23, 0.35, 0.36, 0.53, 0.53, 0.63, 0.65]
    },
    {
      ad: "Tekstil Teknolojileri ve Tasarımı Fakültesi",
      veriler: [1.75, 1.33, 1.42, 1.29, 1.83, 2.00, 1.86, 1.42]
    },
    {
      ad: "Bilgisayar ve Bilişim Fakültesi",
      veriler: [0.94, 1.23, 1.29, 1.19, 1.05, 2.26, 1.65, 1.28]
    }
  ]
};

const enstituOgretimUyesiBasinaMakaleOptions = {
  chart: {
    type: 'column',
    height: 600
  },
  title: {
    text: `${institutionShortName} Enstitü Bazında Öğretim Üyesi Başına Makale + Review Sayısı`
  },
  xAxis: {
    categories: enstituOgretimUyesiBasinaMakaleVerileri.yillar,
    labels: {
      rotation: -45
    }
  },
  yAxis: {
    title: {
      text: 'Makale Sayısı'
    }
  },
  plotOptions: {
    column: {
      pointPadding: 0.2,
      borderWidth: 0
    },
    line: {
      lineWidth: 3,
      marker: {
        enabled: true,
        radius: 6
      }
    }
  },
  series: [
    {
      name: 'İTÜ',
      type: 'line',
      data: enstituOgretimUyesiBasinaMakaleVerileri.enstituler.find(f => f.ad === "İTÜ").veriler,
      color: '#FF0000',
      zIndex: 2,
      lineWidth: 3,
      marker: {
        enabled: true,
        radius: 6
      }
    },
    ...enstituOgretimUyesiBasinaMakaleVerileri.enstituler
      .filter(fakulte => fakulte.ad !== "İTÜ")
      .map(fakulte => ({
        name: fakulte.ad,
        type: 'column',
        data: fakulte.veriler
      }))
  ]
};

const DetailedTable = ({ data }) => (
  <div className="detailed-table">
    <table>
      <thead>
        <tr>
          <th>Metrik</th>
          {data.yillar.map(yil => (
            <th key={yil}>{yil}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.veriler.map((row, index) => (
          <tr key={index}>
            <td>{row.baslik}</td>
            {row.degerler.map((deger, i) => (
              <td key={i}>{deger}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const MetricCard = ({ title, value, previousYear, trend }) => (
  <div className="metric-card">
    <h3 className="metric-title">{title}</h3>
    <div className="metric-value">{value}</div>
    <div className={`metric-trend ${parseFloat(trend) > 0 ? 'positive' : 'negative'}`}>
      {trend}
    </div>
  </div>
);

const Publications = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilters, setSelectedFilters] = useState({
    yillar: [],
    indeksler: [],
    qKategorileri: [],
    bolumler: [],
    yayinTurleri: []
  });

  const qDagilimiOptions = {
    chart: {
      type: 'column',
      height: 400
    },
    title: {
      text: `${institutionShortName} Q1-Q2-Q3-Q4 DAĞILIMI`
    },
    xAxis: {
      categories: ituYayinVerileri.yillar
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: 'Yüzde (%)'
      }
    },
    plotOptions: {
      column: {
        stacking: 'normal'
      }
    },
    series: [
      {
        name: 'Q1',
        data: ituYayinVerileri.q1Yuzde,
        color: '#4CAF50'
      },
      {
        name: 'Q2',
        data: ituYayinVerileri.q2Yuzde,
        color: '#8BC34A'
      },
      {
        name: 'Q3',
        data: ituYayinVerileri.q3Yuzde,
        color: '#FFC107'
      },
      {
        name: 'Q4',
        data: ituYayinVerileri.q4Yuzde,
        color: '#FF5722'
      }
    ]
  };

  const yillikTrendOptions = {
    chart: {
      type: 'line',
      height: 400
    },
    title: {
      text: `${institutionShortName} Yıllık Trend`
    },
    xAxis: {
      categories: ituYayinVerileri.yillar
    },
    yAxis: {
      title: {
        text: 'Değer'
      }
    },
    series: [
      {
        name: 'Toplam Yayın',
        data: ituYayinVerileri.toplamYayin
      },
      {
        name: 'Atıf Sayısı',
        data: ituYayinVerileri.atifSayisi
      },
      {
        name: 'Öğretim Üyesi Başına Yayın',
        data: ituYayinVerileri.ogretimUyesiBasinaYayin
      },
      {
        name: 'Öğretim Üyesi Başına Atıf',
        data: ituYayinVerileri.ogretimUyesiBasinaAtif
      },
      {
        name: 'Öğretim Üyesi Başına Q1',
        data: ituYayinVerileri.ogretimUyesiBasinaQ1
      }
    ]
  };

  const summaryData = {
    totalArticles: {
      title: "Toplam Makale",
      description: "Toplam makale sayısı",
      currentYear: toplamMakaleBilgileri.toplamMakale2024,
      lastFiveYears: toplamMakaleBilgileri.toplamMakaleSonBesYil
    },
    q1Articles: {
      title: "Q1 Makaleler",
      description: "Q1 kategorisindeki makaleler",
      currentYear: toplamMakaleBilgileri.q1.sayi2024,
      percentage: toplamMakaleBilgileri.q1.yuzde2024,
      total: toplamMakaleBilgileri.q1.sonBesYil
    },
    q2Articles: {
      title: "Q2 Makaleler",
      description: "Q2 kategorisindeki makaleler",
      currentYear: toplamMakaleBilgileri.q2.sayi2024,
      percentage: toplamMakaleBilgileri.q2.yuzde2024,
      total: toplamMakaleBilgileri.q2.sonBesYil
    },
    mrArticles: {
      title: "M/R Makaleler",
      description: "Makale ve Review sayıları",
      currentYear: toplamMakaleBilgileri.mr.sayi2024,
      total: toplamMakaleBilgileri.mr.sonBesYil
    },
    facultyStats: {
      title: "Öğretim Üyesi İstatistikleri",
      description: "Öğretim üyesi başına düşen yayın sayıları",
      totalFaculty: ituOzetBilgileri.ogretimUyesiSayisi,
      articlesPerFaculty: ituOzetBilgileri.ogretimUyesiBasinaMRSayisi2024,
      q1q2PerFaculty: ituOzetBilgileri.ogretimUyesiBasinaQ1Q22024,
      mrPerFaculty: ituOzetBilgileri.ogretimUyesiBasinaMRSayisi2024
    }
  };

  return (
    <div className="wrapper">
      <PageHeader 
        title={t('publications.pageTitle')}
        description={t('publications.pageDescription')}
        breadcrumbs={[
          { text: 'Ana Sayfa', href: '/' },
          { text: 'Yayınlar'},
        ]}
      />
      

      <div className="total-publications">
        <div className="institution-header">
          <h2>{t('institution.name')}</h2>
          <div className="institution-type">{t('institution.type')}</div>
        </div>
        <div class="summary-row">
          <div className="summary-item">
            <span>{t('publications.totalPublications.currentYear')}:</span>
            <span>{toplamMakaleBilgileri.toplamMakale2024}</span>
          </div>
          <div className="summary-item">
            <span>{t('publications.totalPublications.lastFiveYears')}:</span>
            <span>{toplamMakaleBilgileri.toplamMakaleSonBesYil}</span>
          </div>
        </div>
        <div className="summary-row">
          <div className="summary-item">
            <span>Öğretim Üyesi Sayısı :</span>
            <span>{ituOzetBilgileri.ogretimUyesiSayisi}</span>
          </div>
          <div className="summary-item">
            <span>Makale ve Review Sayısı (2024) :</span>
            <span>{ituOzetBilgileri.makaleVeReviewSayisi2024}</span>
          </div>
        </div>
        <div className="summary-row">
          <div className="summary-item">
            <span>Öğretim Üyesi Başına Q1 + Q2 (2024) :</span>
            <span>{ituOzetBilgileri.ogretimUyesiBasinaQ1Q22024}</span>
          </div>
          <div className="summary-item">
            <span>Öğretim Üyesi Başına M-R Sayısı (2024) :</span>
            <span>{ituOzetBilgileri.ogretimUyesiBasinaMRSayisi2024}</span>
          </div>
        </div>
        <div className="summary-row">
          <div className="summary-item">
            <span>Öğretim Üyesi Başına Q1 (2024) :</span>
            <span>{ituOzetBilgileri.ogretimUyesiBasinaQ12024}</span>
          </div>
          <div className="summary-item">
            <span>Öğretim Üyesi Başına Q2 (2024) :</span>
            <span>{ituOzetBilgileri.ogretimUyesiBasinaQ22024}</span>
          </div>
        </div>
        <div className="summary-row">
          <div className="summary-item">
            <span>Q1 (2024) :</span>
            <span>{ituOzetBilgileri.q12024}</span>
          </div>
          <div className="summary-item">
            <span>Q2 (2024) :</span>
            <span>{ituOzetBilgileri.q22024}</span>
          </div>
        </div>
        <div className="summary-row">
          <div className="summary-item">
            <span>Q1 + Q2 (2024) :</span>
            <span>{ituOzetBilgileri.q1q22024}</span>
          </div>
        </div>
        <div className="summary-row">
          <div className="summary-item">
            <span>Q1 Yüzdesi :</span>
            <span>%{ituOzetBilgileri.q1Yuzdesi}</span>
          </div>
          <div className="summary-item">
            <span>Q2 Yüzdesi :</span>
            <span>%{ituOzetBilgileri.q2Yuzdesi}</span>
          </div>
        </div>
        <div className="summary-row">
          <div className="summary-item">
            <span>Q1 + Q2 Yüzdesi :</span>
            <span>%{ituOzetBilgileri.q1q2Yuzdesi}</span>
          </div>
        </div>
      </div>

      <div className="q-cards">
        <div className="q-card q1">
          <div className="title">Q1 Verileri</div>
          <div className="year-data">
            <div className="year">2024</div>
            <div className="value">{toplamMakaleBilgileri.q1.sayi2024}</div>
            <div className="percentage">%{toplamMakaleBilgileri.q1.yuzde2024}</div>
          </div>
          <div className="total-data">
            <div>Son Beş Yıl</div>
            <div className="value">{toplamMakaleBilgileri.q1.sonBesYil}</div>
          </div>
        </div>

        <div className="q-card q2">
          <div className="title">Q2 Verileri</div>
          <div className="year-data">
            <div className="year">2024</div>
            <div className="value">{toplamMakaleBilgileri.q2.sayi2024}</div>
            <div className="percentage">%{toplamMakaleBilgileri.q2.yuzde2024}</div>
          </div>
          <div className="total-data">
            <div>Son Beş Yıl</div>
            <div className="value">{toplamMakaleBilgileri.q2.sonBesYil}</div>
          </div>
        </div>

        <div className="q-card mr">
          <div className="title">D. M/R Verileri</div>
          <div className="year-data">
            <div className="year">2024</div>
            <div className="value">{toplamMakaleBilgileri.mr.sayi2024}</div>
          </div>
          <div className="total-data">
            <div>Son Beş Yıl</div>
            <div className="value">{toplamMakaleBilgileri.mr.sonBesYil}</div>
          </div>
        </div>
      </div>

      <div className="summary-cards-grid container-fluid">
        <div class="row">
          <div class="col-md-4">
              <SummaryCard
                type="totalArticles"
                title={summaryData.totalArticles.title}
                description={summaryData.totalArticles.description}
                data={{
                  "Bu Yıl": summaryData.totalArticles.currentYear,
                  "Son 5 Yıl": summaryData.totalArticles.lastFiveYears
                }}
              />
          </div>
          <div class="col-md-4">
            <SummaryCard
              type="q1Articles"
              title={summaryData.q1Articles.title}
              description={summaryData.q1Articles.description}
              data={{
                "Bu Yıl": summaryData.q1Articles.currentYear,
                "Yüzde": `%${summaryData.q1Articles.percentage}`,
                "Toplam": summaryData.q1Articles.total
              }}
            />
          </div>
          <div class="col-md-4">
              <SummaryCard
                type="q2Articles"
                title={summaryData.q2Articles.title}
                description={summaryData.q2Articles.description}
                data={{
                  "Bu Yıl": summaryData.q2Articles.currentYear,
                  "Yüzde": `%${summaryData.q2Articles.percentage}`,
                  "Toplam": summaryData.q2Articles.total
                }}
              />
          </div>
          <div class="col-md-4">
            <SummaryCard
              type="mrArticles"
              title={summaryData.mrArticles.title}
              description={summaryData.mrArticles.description}
              data={{
                "Bu Yıl": summaryData.mrArticles.currentYear,
                "Toplam": summaryData.mrArticles.total
              }}
            />
          </div>
          <div class="col-md-4">
            <SummaryCard
              type="facultyStats"
              title={summaryData.facultyStats.title}
              description={summaryData.facultyStats.description}
              data={{
                "Toplam": summaryData.facultyStats.totalFaculty,
                "Yayın/Üye": summaryData.facultyStats.articlesPerFaculty,
                "Q1+Q2/Üye": summaryData.facultyStats.q1q2PerFaculty,
                "M-R/Üye": summaryData.facultyStats.mrPerFaculty
              }}
            />
          </div>


        </div>

    
      </div>


      <div className="numbers-area container-fluid">
      <div className="card">
        <div class="card-header">
          <h3>Fakülte Bazında Q1+Q2 Yüzdesi</h3>
        </div>
        <div class="card-body">

          <div className="chart-container">
            <HighchartsReact 
              highcharts={Highcharts} 
              options={q1q2YuzdesiOptions}
            />
          </div>

          <div className="detailed-table">
            <table>
              <thead>
                <tr>
                  <th>Fakülte</th>
                  {fakulteQ1Q2Verileri.yillar.map(yil => (
                    <th key={yil}>{yil}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {fakulteQ1Q2Verileri.fakulteler.map((fakulte, index) => (
                  <tr key={index}>
                    <td>{fakulte.ad}</td>
                    {fakulte.veriler.map((deger, i) => (
                      <td key={i}>%{deger}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>

      <div className="card">
        <div class="card-header">
          <h3>Fakülte Bazında Öğretim Üyesi Başına Makale + Review Sayısı</h3>
        </div>
        <div class="card-body">

          
        <div className="chart-container">
          <HighchartsReact 
            highcharts={Highcharts} 
            options={ogretimUyesiBasinaMakaleOptions}
          />
        </div>

        <div className="detailed-table">
          <table>
            <thead>
              <tr>
                <th>Fakülte</th>
                {ogretimUyesiBasinaMakaleVerileri.yillar.map(yil => (
                  <th key={yil}>{yil}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ogretimUyesiBasinaMakaleVerileri.fakulteler.map((fakulte, index) => (
                <tr key={index}>
                  <td>{fakulte.ad}</td>
                  {fakulte.veriler.map((deger, i) => (
                    <td key={i}>{deger}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </div>
      </div>

      <div className="card">
        <div class="card-header">
          <h3>Enstitü Bazında Q1+Q2 Yüzdesi</h3>
        </div>
        <div class="card-body">

          
        <div className="chart-container">
          <HighchartsReact 
            highcharts={Highcharts} 
            options={enstituOgretimUyesiBasinaMakaleOptions}
          />
        </div>

        <div className="detailed-table">
          <table>
            <thead>
              <tr>
                <th>Enstitü</th>
                {enstituOgretimUyesiBasinaMakaleVerileri.yillar.map(yil => (
                  <th key={yil}>{yil}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {enstituOgretimUyesiBasinaMakaleVerileri.enstituler.map((enstitu, index) => (
                <tr key={index}>
                  <td>{enstitu.ad}</td>
                  {enstitu.veriler.map((deger, i) => (
                    <td key={i}>{deger}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </div>

      </div>

      <div className="card">
        <div class="card-header">
          <h3>Enstitü Bazında Öğretim Üyesi Başına Makale + Review Sayısı</h3>
        </div>
        <div class="card-body">

          
        <div className="chart-container">
          <HighchartsReact 
            highcharts={Highcharts} 
            options={enstituOgretimUyesiBasinaMakaleOptions}
          />
        </div>

        <div className="detailed-table">
          <table>
            <thead>
              <tr>
                <th>Enstitü</th>
                {enstituOgretimUyesiBasinaMakaleVerileri.yillar.map(yil => (
                  <th key={yil}>{yil}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {enstituOgretimUyesiBasinaMakaleVerileri.enstituler.map((enstitu, index) => (
                <tr key={index}>
                  <td>{enstitu.ad}</td>
                  {enstitu.veriler.map((deger, i) => (
                    <td key={i}>{deger}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </div>

      </div>
      </div>


    </div>
  );
};

export default Publications; 